<div 
  [class]="pillClasses()"
  [ngStyle]="pillStyles()"
  [attr.data-animation]="animationValue()"
  [attr.data-size]="sizeValue()"
  role="status"
  [attr.aria-label]="textValue()">
  
  @if (hasText()) {
    <span [class]="textClasses()">
      {{ textValue() }}
    </span>
  }
  
  <!-- Shimmer overlay for shimmer animation -->
  @if (animationValue() === 'shimmer' && animationEnabledValue()) {
    <div class="pill-soon__shimmer" aria-hidden="true"></div>
  }
  
  <!-- Glow overlay for glow animation -->
  @if (animationValue() === 'glow' && animationEnabledValue()) {
    <div class="pill-soon__glow" aria-hidden="true"></div>
  }
  
  <!-- Swing overlay for swing animation -->
  @if (animationValue() === 'swing' && animationEnabledValue()) {
    <div class="pill-soon__swing" aria-hidden="true"></div>
  }
</div>